import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import DetailComponent from '../components/PortfolioDetailComponent';

const PortfolioDetail = () => {
  const { id } = useParams();
  const item = useSelector((state) => state.works.find((w) => w.id === +(id || 0)));

  if (!item) {
    return (
      <div className="min-h-screen bg-background-dark text-slate-100 font-display flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold text-slate-100 mb-4">Project not found</h1>
          <Link to="/portfolio" className="text-accent hover:underline">Back to Portfolio</Link>
        </div>
      </div>
    );
  }

  return <DetailComponent item={item} />;
};

export default PortfolioDetail;
